var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 15.5H14.5938M9.125 19.875H14.5938M9.125 24.25H14.5938M18.9688 25.3438H22.25C23.1202 25.3438 23.9548 24.998 24.5702 24.3827C25.1855 23.7673 25.5313 22.9327 25.5313 22.0625V6.9075C25.5313 5.25229 24.299 3.84792 22.6496 3.71083C22.1042 3.6656 21.5582 3.62671 21.0119 3.59417M21.0119 3.59417C21.1086 3.90783 21.1563 4.23424 21.1563 4.5625C21.1563 4.85258 21.041 5.13078 20.8359 5.3359C20.6308 5.54102 20.3526 5.65625 20.0625 5.65625H13.5C12.8963 5.65625 12.4063 5.16625 12.4063 4.5625C12.4063 4.22563 12.4573 3.90042 12.5521 3.59417M21.0119 3.59417C20.805 2.92423 20.3874 2.33819 19.8232 1.92196C19.2589 1.50573 18.5762 1.28119 17.875 1.28125H15.6875C14.9864 1.28141 14.3038 1.50604 13.7395 1.92225C13.1753 2.33845 12.7592 2.92435 12.5521 3.59417M12.5521 3.59417C12.0038 3.62771 11.4583 3.66708 10.9129 3.71083C9.26354 3.84792 8.03125 5.25229 8.03125 6.9075V10.0313M8.03125 10.0313H3.10938C2.20375 10.0313 1.46875 10.7663 1.46875 11.6719V28.0781C1.46875 28.9838 2.20375 29.7188 3.10938 29.7188H17.3281C18.2338 29.7188 18.9688 28.9838 18.9688 28.0781V11.6719C18.9688 10.7663 18.2338 10.0313 17.3281 10.0313H8.03125ZM5.84375 15.5H5.85542V15.5117H5.84375V15.5ZM5.84375 19.875H5.85542V19.8867H5.84375V19.875ZM5.84375 24.25H5.85542V24.2617H5.84375V24.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.53e67df9cfa39ea1814409b83d1d168e.svg";
export { ForwardRef as ReactComponent };